import AddGridsTab from './AddGridsTab'
import PreviewSubjectTab from '../PreviewSubjectTab'

const CreateSubjectContent = ({
  addGrid,
  activeTab,
  availableGrids,
  isLoading,
  difficultyFilters,
  handleSelectDifficulty,
  filteredTags,
  setFilteredCorrect,
  setFilteredTags,
  filteredCorrect,
  closeModal,
  filtersPopupOpened,
  setFiltersPopupOpened,
  setDifficultyFilters,
  searchedValue,
  handleSearchValue,
  subject,
  onSuccessCreateSubject,
  removeGrid,
  handleChangeChaptersByCourse,
  sources,
  selectedSource,
  handleChangeSource,
  grileTypes,
  handleChangeGrileTypes,
}) => {
  if (activeTab === 0) {
    return (
      <AddGridsTab
        handleChangeGrileTypes={handleChangeGrileTypes}
        grileTypes={grileTypes}
        sources={sources}
        selectedSource={selectedSource}
        handleChangeSource={handleChangeSource}
        handleChangeChaptersByCourse={handleChangeChaptersByCourse}
        handleSearchValue={handleSearchValue}
        searchedValue={searchedValue}
        setDifficultyFilters={setDifficultyFilters}
        setFiltersPopupOpened={setFiltersPopupOpened}
        difficultyFilters={difficultyFilters}
        handleSelectDifficulty={handleSelectDifficulty}
        filteredTags={filteredTags}
        setFilteredCorrect={setFilteredCorrect}
        setFilteredTags={setFilteredTags}
        filteredCorrect={filteredCorrect}
        closeModal={closeModal}
        filtersPopupOpened={filtersPopupOpened}
        isLoading={isLoading}
        addGrid={addGrid}
        availableGrids={availableGrids}
      />
    )
  }
  if (activeTab === 1) {
    return (
      <PreviewSubjectTab
        removeGrid={removeGrid}
        onSuccessCreateSubject={onSuccessCreateSubject}
        subject={subject}
      />
    )
  }
}

export default CreateSubjectContent
